<template>
    <v-form ref="form">
        <div>
            <div class="label">Tipo da alteração <span class="red--text">*</span></div>
            <v-select
                v-model="selectedType"
                :items="typeItems"
                @change="onTypeChange"
                label="Selecione"
                :rules="[rules.required]"
                outlined
                dense
            />
        </div>
        <div v-if="selectedType">
            <div class="label">Alteração solicitada <span class="red--text">*</span></div>
            <v-select
                v-model="selectedSubtype"
                :items="subtypeItems"
                @change="onSubtypeChange"
                label="Selecione"
                :rules="[rules.required]"
                outlined
                dense
            />
        </div>
        <template v-if="selectedSubtype">
            <div>
                <div class="label">Correção desejada <span class="red--text">*</span></div>
                <v-text-field v-if="correctionFieldType === 'date'"
                    v-model="correction"
                    type="date"
                    :rules="[rules.required]"
                    outlined
                    dense
                />
                <v-text-field v-else-if="correctionFieldType === 'number'"
                    v-model="correction"
                    type="number"
                    prefix="R$"
                    :rules="[rules.required, rules.positiveNumber]"
                    outlined
                    dense
                />
                <v-text-field v-else
                    v-model="correction"
                    type="text"
                    :rules="[rules.required]"
                    outlined
                    dense
                />
            </div>
        </template>
        <div>
            <div class="label">Comentário (opcional)</div>
            <v-textarea
                v-model="comment"
                label="Comentário adicional..."
                auto-grow
                outlined
                dense
            />
        </div>
    </v-form>
</template>

<script>
const options = {
    unavailable: {
        label: 'Indisponível',
        subtypes: {
            unavailability: { label: 'Não há disponibilidade', fieldType: 'text' },
        },
    },
    dates: {
        label: 'Datas e Horários',
        subtypes: {
            checkin: { label: 'Data de check-in incorreta', fieldType: 'date' },
            checkout: { label: 'Data de check-out incorreta', fieldType: 'date' },
            duration: { label: 'Duração da estadia incorreta', fieldType: 'text' },
        },
    },
    accommodation: {
        label: 'Acomodação',
        subtypes: {
            room_type: { label: 'Tipo de quarto incorreto', fieldType: 'text' },
            bed_type: { label: 'Tipo de cama incorreto', fieldType: 'text' },
        },
    },
    supplier: {
        label: 'Fornecedor',
        subtypes: {
            wrong_hotel: { label: 'Hotel diferente do solicitado', fieldType: 'text' },
            wrong_location: { label: 'Localização do hotel incorreta', fieldType: 'text' },
        },
    },
    commercial: {
        label: 'Valores e Condições Comerciais',
        subtypes: {
            total_value: { label: 'Valor total divergente', fieldType: 'number' },
            fees: { label: 'Taxas não informadas ou incorretas', fieldType: 'text' },
            currency: { label: 'Moeda incorreta', fieldType: 'text' },
        },
    },
    services: {
        label: 'Serviços Adicionais',
        subtypes: {
            breakfast: { label: 'Café da manhã não incluído', fieldType: 'text' },
            extras: { label: 'Serviços extras não confirmados (Wi-Fi, estacionamento, transfer)', fieldType: 'text' },
            insurance: { label: 'Seguro viagem ausente ou incorreto', fieldType: 'text' },
        },
    },
    payment: {
        label: 'Informações de Pagamento',
        subtypes: {
            wrong_payment_method: { label: 'Forma de pagamento incorreta', fieldType: 'text' }
        }
    }
};

export default {
    name: 'CancelReserveForm',

    data: () => ({
        selectedType: null,
        selectedSubtype: null,
        correction: null,
        comment: null,

        rules: {
            required: v => !!v || 'Campo Obrigatório',
            positiveNumber: v => (v > 0) || 'O valor deve ser positivo'
        }
    }),

    computed: {
        typeItems() {
            return Object.entries(options).map(([value, { label }]) => ({ value, text: label }))
        },

        subtypeItems() {
            if (!this.selectedType) return []
            return Object.entries(options[ this.selectedType ].subtypes).map(([value, { label }]) => ({ value, text: label }))
        },

        correctionFieldType() {
            if (!this.selectedSubtype) return null
            return options[ this.selectedType ].subtypes[ this.selectedSubtype ].fieldType
        }        
    },

    methods: {
        onTypeChange() {
            this.selectedSubtype = null
            this.correction = null
        },

        onSubtypeChange() {
            this.correction = null
        },

        getFormData() {
            const isFormValid = this.$refs.form.validate()
            if (!isFormValid) return null

            return {
                adjustmentType: this.selectedType,
                adjustmentSubtype: this.selectedSubtype,
                adjustmentCorrection: this.correction,
                adjustmentComment: this.comment
            }
        },

        formatToString() {
            const typeLabel = options[this.selectedType]?.label ?? this.selectedType
            const subtypeLabel = options[this.selectedType]?.subtypes[this.selectedSubtype]?.label ?? this.selectedSubtype

            let result = `Tipo: ${typeLabel} | Alteração: ${subtypeLabel} | Correção: ${this.correction}`
            if (this.comment) {
                result += ` | Comentário: ${this.comment}`
            }
            return result
        },

        clearForm() {
            this.selectedType = null
            this.selectedSubtype = null
            this.correction = null
            this.comment = null
        }
    },
};
</script>

<style scoped>
.label {
    text-align: left;
    padding-bottom: 8px;
}
</style>
